import React from 'react';

import { Icon } from '../icons';

export const KeyboadReturnIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 32 32" fill={color} style={style}>
      <polygon points="27.0676692 10.4761905 27.0676692 15.8095238 7.35398496 15.8095238 12.0914286 11.0228571 10.2255639 9.14285714 2.28571429 17.1428571 10.2255639 25.1428571 12.0914286 23.2628571 7.35398496 18.4761905 29.7142857 18.4761905 29.7142857 10.4761905" />
    </svg>
  );
};
